export type DxFilterGroupOperator = 'and' | 'or';

export function isDxFilterGroupOperator(
  element: any,
): element is DxFilterGroupOperator {
  return element === 'and' || element === 'or';
}
